// import router from '@/router'
// import {
// 	MessageBox
// } from 'element-ui'
import {
	login,
	logout
} from '@/api/login'
import {
	getToken,
	setToken,
	removeToken
} from '@/utils/auth'
// import { isHttp, isEmpty } from "@/utils/validate"
// import defAva from '@/assets/images/profile.jpg'

const user = {
	state: {
		token: getToken(),
		id: '',
		nickname: '',
		avatar: ''
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_ID: (state, id) => {
			state.id = id
		},
		SET_NICK_NAME: (state, nickname) => {
			state.nickname = nickname
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		}
	},

	actions: {
		// 登录
		Login({
			commit
		}, userInfo) {
			const email = userInfo.email.trim()
			const pwd = userInfo.pwd
			return new Promise((resolve, reject) => {
				login({
					email: email,
					pwd
				}).then(res => {
					setToken(res.data.token)
					commit('SET_TOKEN', res.data.token)
					commit('SET_ID', res.data.user.id)
					commit('SET_NICK_NAME', res.data.user.nickname)
					commit('SET_AVATAR', res.data.user.avatar)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},



		// 退出系统
		LogOut({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				logout(state.token).then(() => {
					commit('SET_TOKEN', '')
					removeToken()
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 前端 登出
		FedLogOut({
			commit
		}) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '')
				removeToken()
				resolve()
			})
		}
	}
}

export default user